export const EMPTY_STATE_TYPES = {
  RECIPE_NOT_SOLD: 'recipeNotSold',
  NO_CENTRAL: 'noCentral',
};
